import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

const NotFoundSection = ({ routeData }) => {
  return (
    <div className="notfound-container">
      <div className="question-container">
        <img
          alt=""
          src={require("@/assets/images/404-not-found-question.svg")}
        />
        <div className="title">お探しのページは見つかりませんでした</div>
        <div className="description">
          いつもTrynibusをご利用いただきありがとうございます。
          <br />
          アクセスしようとしたページは削除もしくはURLが変更されているため、見つけることができません。
        </div>
      </div>
      <Placeholder
        name="jss-contact"
        rendering={routeData}
        routeData={routeData}
      />
    </div>
  );
};

export default NotFoundSection;
